module.exports = __webpack_public_path__ + "img/u144.8fc6f81a.jpg";